import { render, staticRenderFns } from "./SidebarNavProfile.vue?vue&type=template&id=1d057396&"
import script from "./SidebarNavProfile.vue.ts?vue&type=script&lang=ts&"
export * from "./SidebarNavProfile.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports